import React from 'react';
import Icon from './Icon';
import ValidatorBoard from './ValidatorBoard';

import classNames from 'classnames';

export default class Input extends React.Component{

  constructor(props){
    super(props);
this.handleChange=this.handleChange.bind(this);
this.handleFocus=this.handleFocus.bind(this);
this.handleBlur=this.handleBlur.bind(this);
this.mouseEnterError=this.mouseEnterError.bind(this);
this.hideError=this.hideError.bind(this);
    this.state= {
      valid: (this.props.isValid && this.props.isValid()) || true,
        validCustom: (this.props.isValid && this.props.isValid()) || true,
      empty: (this.props.value == null || this.props.value === ''),
      focus: false,
      value: this.props.value,
      iconsVisible: !this.props.validator,
      errorMessage: this.props.errorMessage,
      instaCheckMsg:this.props.instacheckmsg,
      hint:(this.props.hint==undefined || this.props.hint==null)?false: this.props.hint,
      validator: this.props.validator,
      validatorVisible: false,
      type: this.props.type,
      errorVisible:false,
        instaError:false,
      minCharacters: this.props.minchars,
        maxCharacters: this.props.maxchars,
      requireCapitals: this.props.reqcapitals,
      requireNumbers: this.props.reqnumbers,
      requireSplChars: this.props.reqsplchars,
      forbiddenWords: this.props.forbiddenWords,
      changed:false,
      isValidatorValid: {
        minChars: false,
          maxChars: false,
        capitalLetters: false,
        numbers: false,
        splchars: false,
        words: false,
        all: false
      },
      allValidatorValid: false
    };
  }

    handleChange(event){

    this.setState({
      value: event.target.value,
      empty: this.isEmpty(event.target.value),
      changed:true
    });

    if(this.props.validator) {
       if(this.props.validator=="true"){
      this.checkRules(event.target.value)
    }
    }

    if(this.props.validate) {

          this.validateInput(event.target.value);
        }

    // call onChange method on the parent component for updating it's state
    if(this.props.onChange) {
      this.props.onChange(event);
    }
  }
   isEmpty(value){
    return (value == null || value === '' || (typeof(value)==="string" && value.trim()===''));
  }
   isUndefined(value){
    return (value === undefined);
  }
  validateInput(value) {
     // trigger custom validation method in the parent component
     if(this.props.validate && this.props.validate(value)){

       this.setState({
         validCustom: true,
         errorVisible: false
       });
     } else {

       this.setState({
         validCustom: false,
          valid: false,
          errorVisible: true,
         errorMessage: !this.isEmpty(value) ? this.props.errorMessage : this.props.emptyMessage
       });
     }

   }

   componentWillReceiveProps(newProps) {
      // perform update only when new value exists and not empty
// 9/01/2018 updated code related to empty value assignment or reset state...check svn log
      if(newProps.value || newProps.value=="") {

          this.setState({
            value: newProps.value,
            empty: this.isEmpty(newProps.value)
          });

      }
    }

    isValid() {
     if(this.props.validate) {

       if((this.isEmpty(this.state.value) && (!(this.props.minchars=="0"))) || !this.props.validate(this.state.value)) {

         this.setState({
           validCustom: false,
           valid:false,
           errorVisible: true
         });

     }else{
       this.setState({
         validCustom: true,

         errorVisible: false
       });
     }

   }
   if(this.props.validator){
     if(this.props.validator=="true"){
    this.checkRules(this.state.value);
  }
  }
  // to be uncommented if bugs found on testing during instacheck..
  // if(this.props.instacheck){
  //   this.instaCheckValidator();
  // }

       return this.state.valid &&  !this.state.instaError &&  this.state.validCustom && !((this.isEmpty(this.state.value) && (!(this.props.minchars=="0"))));

   }
   //temp code created by Preeth Unni Nair : to be deleted afetr complete testing
 //   reValidate() {
 //
 //    if(this.props.validate) {
 //
 //      if((this.isEmpty(this.state.value) && (!(this.props.minchars=="0"))) || !this.props.validate(this.state.value)) {
 //
 //        this.setState({
 //          validCustom: false,
 //          valid:false,
 //          errorVisible: true
 //        });
 //
 //    }else{
 //      this.setState({
 //        validCustom: true,
 //        valid:true,
 //        errorVisible: true
 //      });
 //    }
 //
 //  }
 //  if(this.props.validator){
 //   this.checkRules(this.state.value);
 // }
 //
 //
 //  }
    handleFocus() {
    this.setState({
      focus: true

    });

    // hide error when validator is active
    // if(this.props.validator) {
    //   this.setState({
    //     errorVisible: false
    //   })
    // }
  }

    handleBlur() {
      this.setState({
        focus: false


      });
    this.instaCheckValidator()

  }
  instaCheckValidator(){
    if(this.props.instacheck){
      this.props.instacheck(this.state.value).then((response)=>{

      if(response!=true){

        this.setState({


          instaError: true,
           instaCheckMsg: response
        });
      }else{
        this.setState({


          instaError: false,
           instaCheckMsg: response
        });
      }
    })

  }
  }

    mouseEnterError() {
    this.setState({

      validatorVisible: true

    });
  }


    hideError() {
    this.setState({

      validatorVisible: false
    });
  }

  // validator function
    checkRules(data) {
      let value = null;
      if(!this.isEmpty(data))
      {
        value = data.toString();
      }
      else
      {
        value = "";
      }

    var validData = {
      minChars: !this.isEmpty(value)  ? value.length >= parseInt(this.state.minCharacters): false,
      maxChars: !this.isEmpty(value) ? value.length <= parseInt(this.state.maxCharacters): false,
      capitalLetters: !this.isEmpty(value) ? this.checkCapitals(value,this.state.requireCapitals): false,
      numbers: !this.isEmpty(value) ? this.checkNumbers(value,this.state.requireNumbers) : false,
      splchars: !this.isEmpty(value) ? this.checkSplChars(value,this.state.requireSplChars) : false

    }
    if(this.isEmpty(value) && this.props.minchars=="0"){
      validData = {
        minChars: true,
        maxChars: true,
        capitalLetters: true,
        numbers: true,
        splchars:true

      }
    }
    var allValid = (validData.minChars && validData.maxChars && validData.capitalLetters && validData.numbers && validData.splchars);

    this.setState({
      isValidatorValid: validData,
      allValidatorValid: allValid,
      valid: allValid
    })
  }

    checkCapitals(value,rule) {
    var str = value;
    switch((/[A-Z]/g).test(str)){
      case false:
      if(rule=="NRN" || rule=="NRA"){
        return true;
      }else{
        return false;
      }
      break;
        case true:
      if(rule=="R" || rule=="NRA"){
        return true;
      }else {
        return false;
      }
      break;
    }
  }

    checkNumbers(value,rule) {
      var str = value;

      switch((/[0-9]/g).test(str)){
        case false:
        if(rule=="NRN" || rule=="NRA"){
          return true;
        }else{
          return false;
        }
        break;
        case true:
        if(rule=="R" || rule=="NRA"){
          return true;
        }else {
          return false;
        }
        break;
      }

  }
  checkSplChars(value,rule) {
    var str = value;

    switch((/[@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g).test(str)){
      case false:
      if(rule=="NRN" || rule=="NRA" ){
        return true;
      }else{
        return false;
      }
      break;
      case true:
      if(rule=="R" || rule=="NRA"){
        return true;
      }else {
        return false;
      }
      break;
    }


}


   render(){

    var inputGroupClasses = classNames({
      'input_group':     true,
      'input_valid':     this.state.valid && this.state.validCustom && !this.state.instaError && this.state.validator=="true",
      'input_error':     (!this.state.valid || !this.state.validCustom || this.state.instaError ) && this.state.validator=="true",
      'input_empty':     this.state.empty,
      'input_hasValue':  !this.state.empty,
      'input_focused':   this.state.focus,
      'input_unfocused': !this.state.focus,
      'input_onChange':this.state.changed
    });

    var validator;
    if(this.state.validator || !this.state.changed ) {
      if(this.state.validator=="true"){
         validator =
<ValidatorBoard
             ref="passwordValidator"
             visible={this.state.validatorVisible && (this.state.focus || (!this.state.valid || !this.state.validCustom || this.state.instaError ) && this.state.validator=="true" )}
             name={this.props.text}
             errorMessage={this.state.errorMessage}
              instaCheckMsg={this.state.instaCheckMsg}
             errorVisible={this.state.errorVisible}
              instaError={this.state.instaError}
             value={this.state.value}
             hint={this.state.hint}
             validData={this.state.isValidatorValid}
             valid={this.state.allValidatorValid}
              reqsplchars={this.props.reqsplchars}
             minchars={this.props.minchars}
             maxchars={this.props.maxchars}
             reqcapitals={this.props.reqcapitals}
             reqnumbers={this.props.reqnumbers}
           />
       }
}


    return (
<div className={inputGroupClasses}>
	<label class="control-label" htmlFor={this.props.text}>{this.props.text}{this.props.mandatory?<span class="text-danger">*</span>:null}</label>

	<input
          {...this.props}
          placeholder={this.props.placeholder}
          id={this.props.id?this.props.id:this.props.text}
          defaultValue={this.props.defaultValue}
          
          value={this.state.value}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          autoComplete="off"
          type="text"
        />



	<div className="validationIcons">
		<i className="input_error_icon" onMouseEnter={this.mouseEnterError} onMouseLeave={this.hideError}>
			<Icon type="circle_error"/>
		</i>
		<i className="input_valid_icon" >
			<Icon type="circle_tick"/>
		</i>
    {this.props.hint && this.state.focus?<i className="input_hint_icon" onMouseEnter={this.mouseEnterError} onMouseLeave={this.hideError}>
			<Icon type="hint"/>
		</i>:null}

	</div>

        {validator}

</div>
    );
  }
}
